export default "__VITE_ASSET__4cf62c58__"